document.addEventListener('click', function(event) {
  if (event.target.matches('.brilliantMegaMenu__item--add')) {
    event.preventDefault();
    const variantId = event.target.getAttribute('data-variant-id');
    if (!variantId || event.target.disabled) return;
    event.target.disabled = true;
    try {
      const data = {
        id: variantId,
      }
      fetch('/cart/add.js', {
        method: 'POST',
        headers: {
          'Content-Type': 'application/json',
          'Accept': 'application/json'
        },
        body: JSON.stringify(data)
      })
      .then(response => {
        if (!response.ok) {
          return response.json().then(errData => {
            throw new Error(errData.description || 'Error adding item to cart');
          });
        }
        return response.json();
      })
      .then(item => {
        const miniCart = document.querySelector("mini-cart");
        if (miniCart) {
          miniCart.updateSectionContents();
          miniCart.open(event.target);
        }
      })
      .catch(error => {
        console.error('Error adding item to cart:', error);
      });
    } catch (error) {
      console.error('Error adding item to cart:', error);
    } finally {
      event.target.disabled = false;
    }
  }
});


class GoofRingPreview extends HTMLElement {
  static observedAttributes = ["inside-diameter", "outside-diameter"];
  idOption;
  odOption;
  constructor() {
    // Always call super first in constructor
    super();
    this.innerHTML = `
    <div class="error-message errorMessage">
          ⚠️ Outside Diameter must be larger than Inside Diameter!
      </div>
      <div class="preview-container">
          <div class="ring-canvas ringCanvas">
              <div class="ring">
                  <div class="ring-inner"></div>
              </div>
          </div>
          
          <div class="dimensions">
              <div class="dimension-label">
                  <strong>Inside Diameter:</strong> <span class="idValue">1"</span>
              </div>
              <div class="dimension-label">
                  <strong>Outside Diameter:</strong> <span class="odValue">2"</span>
              </div>
              <div class="dimension-label">
                  <strong>Ring Width:</strong> <span class="widthValue">0.5"</span>
              </div>
          </div>
      </div>
    `
  }

  updateRing() {
      const id = parseFloat(this.getAttribute('inside-diameter'));
      const od = parseFloat(this.getAttribute('outside-diameter'));
      
      const errorMessage = this.querySelector('.errorMessage');
      const previewContainer = this.querySelector('.preview-container');
      console.log(id,od)
      
      if (isNaN(id) || isNaN(od) || typeof id !== 'number' || typeof od !== 'number') {
          this.classList.remove('valid');
          return;
      }
      
      this.classList.add('valid');
      
      // // Validate that OD > ID
      if (od <= id) {
          errorMessage.style.display = 'block';
          previewContainer.style.display = 'none';
      } else {
          errorMessage.style.display = 'none';
          previewContainer.style.display = 'flex';
      }
      
      const ringCanvas = this.querySelector('.ringCanvas');
      const ring = this.querySelector('.ring');
      
      // Calculate the canvas size in pixels
      const canvasSize = ringCanvas.offsetWidth;
      
      // Use the larger diameter to scale
      const maxDiameter = Math.max(od, 23.5);
      const scale = canvasSize / maxDiameter;
      
      // Calculate pixel sizes
      const odPixels = od * scale * 0.9; // 0.9 to leave some margin
      const idPixels = id * scale * 0.9;
      
      // Update ring size
      ring.style.width = `${odPixels}px`;
      ring.style.height = `${odPixels}px`;
      
      // Update inner circle size
      const innerCircle = ring.querySelector('.ring-inner');
      innerCircle.style.width = `${idPixels}px`;
      innerCircle.style.height = `${idPixels}px`;
      innerCircle.style.top = `50%`;
      innerCircle.style.left = `50%`;
      innerCircle.style.transform = `translate(-50%, -50%)`;
      
      // Update displays
      const idDisplayText = this.inchesToFraction(id);
      const odDisplayText = this.inchesToFraction(od);
      const width = ((od - id) / 2).toFixed(2);
      const widthDisplayText = `${width}"`;
      
      this.querySelector('.idValue').textContent = idDisplayText;
      this.querySelector('.odValue').textContent = odDisplayText;
      this.querySelector('.widthValue').textContent = widthDisplayText;
      this.classList.add('valid');
  }

  inchesToFraction(inches) {
    // Separate whole inches from decimal
    const wholeInches = Math.floor(inches);
    const decimal = inches - wholeInches;
    
    // Convert decimal to fraction with denominator of 16 (common for inches)
    // You can adjust this denominator based on your precision needs
    const denominator = 16;
    let numerator = Math.round(decimal * denominator);
    
    // Simplify the fraction
    function gcd(a, b) {
      return b === 0 ? a : gcd(b, a % b);
    }
    
    if (numerator === 0) {
      return `${wholeInches}"`;
    }
    
    if (numerator === denominator) {
      return `${wholeInches + 1}"`;
    }
    
    const divisor = gcd(numerator, denominator);
    numerator = numerator / divisor;
    const simplifiedDenominator = denominator / divisor;
    
    if (wholeInches === 0) {
      return `${numerator}/${simplifiedDenominator}"`;
    }
    
    return `${wholeInches}" ${numerator}/${simplifiedDenominator}`;
  }

  onValueChange() {
    const product = this.closest('.product-info');
    const odSelect = product.querySelector('select[name*="OD"]');
    const idSelect = product.querySelector('select[name*="ID"], select[name*="properties[x]"]');
    const idValue = idSelect ? parseFloat(this.sanitize(idSelect.value)) : null;
    const odValue = odSelect ? parseFloat(this.sanitize(odSelect.value)) : null;
    console.log("GoofRingPreview detected value change:", {idValue, odValue, idSelect: idSelect?.value, odSelect: odSelect?.value});

    if (idValue) {
      this.setAttribute('inside-diameter', idValue);
    }
    if (odValue) {
      this.setAttribute('outside-diameter', odValue);
    }
    this.updateRing();
  }
  sanitize(value) {
    let sanitized = `${value}`.split('OD ').pop().split(':').pop().trim().split(' ').shift().replaceAll('"', '').replaceAll("in", '');
    return sanitized;
  }
  
  connectedCallback() {
    console.log("Custom element added to page.");
    this.onValueChange();
    this.updateRing();
    const product = this.closest('.product-info');
    product.addEventListener('change', (ev) => {
      this.onValueChange();
    })
  }

  disconnectedCallback() {
    console.log("Custom element removed from page.");
  }

  connectedMoveCallback() {
    console.log("Custom element moved with moveBefore()");
    this.updateRing();

  }

  adoptedCallback() {
    console.log("Custom element moved to new page.");
    this.updateRing();

  }

  attributeChangedCallback(name, oldValue, newValue) {
    console.log(`Attribute ${name} has changed.`);
    this.updateRing();
  }
}

customElements.define("goof-ring-preview", GoofRingPreview);